export default "__VITE_ASSET__5a22e9c7__"